// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"4bf69417","488":"c94d9439"}[chunkId] + ".chunk.js";
};